var path = 'app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/advanced.html';
var html = "<form name=\"form\" class=\"container-fluid form-horizontal\" ng-controller=\"cfServerGroupAdvancedCtrl as advancedCtrl\" novalidate>\n  <div class=\"modal-body\">\n    <cf-server-group-advanced-selector command=\"command\" application=\"application\"></cf-server-group-advanced-selector>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/advanced.html
// module id = 1649
// module chunks = 0